import React from 'react';

export default function RibbonBar() {
  return (
    <div className="w-full text-xs sm:text-sm relative z-30" style={{ backgroundColor: '#0f0e1a', color: '#FAFAF9' }}>
      <div className="max-w-7xl mx-auto px-4 py-2 sm:py-2.5 text-center leading-snug">
        <span className="font-semibold" style={{ color: '#10C98F' }}>Year 1 free</span> for the first 1,000 businesses to sign up. Cancel anytime.
      </div>
    </div>
  );
}
